import { PropsWithChildren } from 'react';
import { modalButtons } from '../../../../../styled-system/recipes';

export const ModalButtons = ({ children }: PropsWithChildren) => {
  return <div className={modalButtons()}>{children}</div>;
};
